import React from 'react';

import { connect } from 'react-redux';
import { reduxForm, formValueSelector, InjectedFormProps } from 'redux-form';

import { JobFieldCompensation } from '../../job/fields/job-field-compensation';

import { JobFlowButtons } from './job-flow-buttons';

const FORM_NAME = 'jobFlowCompensation';

const mapStateToProps = (state: any, ownProps: InputProps) => {
  const selector = formValueSelector(FORM_NAME);
  return {
    compensationLow: selector(state, 'compensationLow'),
    compensationHigh: selector(state, 'compensationHigh'),
    initialValues: ownProps.job,
  };
};

interface InputProps extends JobFlowStep {
  job: Partial<Job>;
}

type StateProps = ReturnType<typeof mapStateToProps>;
type JobFlowCompensationComponentProps = InputProps & StateProps;
type JobFlowCompensationFields = Partial<Job>;
type Props = InjectedFormProps<JobFlowCompensationFields, JobFlowCompensationComponentProps> &
  JobFlowCompensationComponentProps;

class JobFlowCompensationComponent extends React.PureComponent<Props> {
  componentDidUpdate(prevProps: Props) {
    if (prevProps.dirty !== this.props.dirty) {
      this.props.onDirty(this.props.dirty);
    }
  }

  submit = (job: JobFlowCompensationFields) => {
    this.props.onNext(job);
  };

  render() {
    const { saving, handleSubmit, change } = this.props;

    return (
      <form onSubmit={handleSubmit(this.submit)}>
        <JobFieldCompensation job={this.props.job} change={change} />
        <JobFlowButtons
          onSkip={this.props.onSkip}
          onPrev={this.props.onPrev}
          editing={this.props.editing}
          saving={saving}
        />
      </form>
    );
  }
}

export const JobFlowCompensation = connect(mapStateToProps)(
  reduxForm<JobFlowCompensationFields, JobFlowCompensationComponentProps>({
    form: FORM_NAME,
  })(JobFlowCompensationComponent),
);
